import styled from '@emotion/styled';
import { Theme } from '@/styles/Theme';

export const Background = styled.div<{ zIndex?: number }>`
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: ${({ zIndex }) => zIndex ?? 1000};
  background: rgba(3, 14, 32, 0.36);
`;

export const Overlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
`;

export const ModalContainer = styled.div<{ width?: string }>`
  position: relative;
  padding: 1.875rem;
  width: ${({ width }) => width ?? '40rem'};
  max-height: 80vh;
  border-radius: 1.25rem;
  background-color: ${Theme.colors.WHITE};
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const CloseWrapper = styled.div`
  flex-shrink: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: left;
  margin-bottom: 1rem;
`;

export const Body = styled.div`
  flex: 1;
  overflow-y: auto;
  min-height: 0;
`;
